/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/filter.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Operation is the operation to apply.
 *
 *  - OPERATION_UNSPECIFIED: Default operation. This operation is not used.
 *  - EQUALS: Operation on scalar values. Only applies to one of |int_value|,
 * |long_value|, |string_value| or |timestamp_value|.
 *  - NOT_EQUALS: Negated EQUALS.
 *  - GREATER_THAN: Greater than operation.
 *  - GREATER_THAN_EQUALS: Greater than or equals operation.
 *  - LESS_THAN: Less than operation.
 *  - LESS_THAN_EQUALS: Less than or equals operation
 *  - IN: Checks if the value is a member of a given array, which should be one of
 * |int_values|, |long_values| or |string_values|.
 *  - IS_SUBSTRING: Checks if the value contains |string_value| as a substring match. Only
 * applies to |string_value|.
 * @export
 */
export const V2beta1PredicateOperation = {
  OPERATION_UNSPECIFIED: 'OPERATION_UNSPECIFIED',
  EQUALS: 'EQUALS',
  NOT_EQUALS: 'NOT_EQUALS',
  GREATER_THAN: 'GREATER_THAN',
  GREATER_THAN_EQUALS: 'GREATER_THAN_EQUALS',
  LESS_THAN: 'LESS_THAN',
  LESS_THAN_EQUALS: 'LESS_THAN_EQUALS',
  IN: 'IN',
  IS_SUBSTRING: 'IS_SUBSTRING',
} as const;
export type V2beta1PredicateOperation =
  (typeof V2beta1PredicateOperation)[keyof typeof V2beta1PredicateOperation];

export function instanceOfV2beta1PredicateOperation(value: any): boolean {
  for (const key in V2beta1PredicateOperation) {
    if (Object.prototype.hasOwnProperty.call(V2beta1PredicateOperation, key)) {
      if (V2beta1PredicateOperation[key as keyof typeof V2beta1PredicateOperation] === value) {
        return true;
      }
    }
  }
  return false;
}

export function V2beta1PredicateOperationFromJSON(json: any): V2beta1PredicateOperation {
  return V2beta1PredicateOperationFromJSONTyped(json, false);
}

export function V2beta1PredicateOperationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V2beta1PredicateOperation {
  return json as V2beta1PredicateOperation;
}

export function V2beta1PredicateOperationToJSON(value?: V2beta1PredicateOperation | null): any {
  return value as any;
}

export function V2beta1PredicateOperationToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): V2beta1PredicateOperation {
  return value as V2beta1PredicateOperation;
}
